import React from "react";
import { Col, Container, Row } from "react-bootstrap";



interface HeaderProps {
    data_bs_theme: string;
}

const Footer: React.FC<HeaderProps> = ({ data_bs_theme }) => {
    return (
        <footer className="footer bg-white text-end pb-1" data-bs-theme={data_bs_theme}>
            <Container fluid>
                <Row className="justify-content-end">
                    <Col xs={12} className="border-top pt-4">
                        <p className="text-dark">© 2026 All Rights Reserved.
                            <a className="d-inline text-dark" href="#privacy-policy"> Privacy Policy</a>.
                            <a className="d-inline text-dark"
                                href="#terms-conditions"
                                title="Use of this platform is subject to our Terms and Conditions available on request from your account manager"
                            > Terms and Conditions</a>.
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
